import { createFromBaseTheme } from "@/style/baseTheme";
import { createTheme, ThemeOptions } from "@mui/material";

import logo from '/images/logo.png'
import logoBar from '/images/logoBar.png'

const customConstants: ThemeOptions = {
  palette: {
    primary: {
      main: "#0e76bd",
    },
    secondary: {
      main: "#579fd1"
    }
  },
  custom: {
    constants: {
      logoImage: logo,
        logoBarImage: logoBar,
    }
  }
};

const baseCustomizedTheme = createFromBaseTheme(customConstants);

const customizations = {}

const newTheme = createTheme(baseCustomizedTheme, customizations);

export default newTheme;

